import {api} from './api';
import type {BiotwinSettings} from '../../features/biotwin-settings/types';

export const biotwinSettingsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBiotwinSettings: builder.query<BiotwinSettings, {userId: number}>({
      query: ({userId}) => ({url: `/biotype-settings?userId=${userId}`, method: 'GET'}),
      providesTags: (_result, _error, arg) => [{type: 'BiotwinSettings', id: arg.userId}],
    }),
    setBiotwinSettings: builder.mutation<BiotwinSettings, {biotwinSettings: BiotwinSettings; userId: number}>({
      query: ({biotwinSettings, userId}) => ({
        url: `/biotype-settings?userId=${userId}`,
        method: 'PUT',
        body: biotwinSettings,
      }),
      invalidatesTags: (_result, _error, arg) => [
        {type: 'Biobook', id: arg.userId},
        {type: 'BiobookChapters', id: arg.userId},
        {type: 'BiobookCounts', id: arg.userId},
      ],
      onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
        const patchResult = dispatch(
          biotwinSettingsApi.util.updateQueryData('getBiotwinSettings', {userId: arg.userId}, (biotwinSettings) => {
            Object.assign(biotwinSettings, arg.biotwinSettings);
          }),
        );
        try {
          await queryFulfilled;
        } catch (e) {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {useGetBiotwinSettingsQuery, useSetBiotwinSettingsMutation} = biotwinSettingsApi;
